// extracted by mini-css-extract-plugin
export default {"vr":"TourDetails_vr__N+UI5","lead":"TourDetails_lead__JCK3z"};